import React from "react";
import WhiteMountain from "./image/white-mountain.jpg";
import TextOnImage from "../components/TextOnImage";

export default function OurTeam() {
  return (
    <>
      {/* Full-Width Image with Text Overlay (1st Section) */}
      <TextOnImage url={WhiteMountain} text={"Our Team"} />

      {/* Card Section with Title and Paragraph */}
      <section className="h-[80vh] flex flex-col justify-center items-center text-center bg-[#eaf7f5] p-6 sm:p-8 md:p-10  ">
        <p className="text-xl md:text-2xl text-gray-600 leading-relaxed md:px-20 sm:px-0">
          PoMA is a global collective of multidisciplinary providers—including
          psychologists, social workers,psychotherapist, community
          practitioners, helpers, and researchers—with deep expertise in
          conflict-affected and low-resource settings. Rooted in a commitment to
          equity and inclusion, the team designs and delivers holistic,
          trauma-informed approaches to psychological and psychosocial support.
          These approaches integrate multiple layers of care, drawing from
          diverse cultural, clinical, and community-based practices. PoMA works
          collaboratively across regions to strengthen local mental health
          systems, support frontline and community providers, and ensure
          accessible, contextually grounded care for vulnerable and marginalized
          populations.
        </p>
      </section>
    </>
  );
}
